<template>
  <div class="d" :class="{ 'loading': loading }">
    <div class="loading-overlay" v-if="loading"></div>
    <div class="p pro">
      <img :src="detail.avatar || defaultAvatar" alt="avatar" />
      <div>
        <div class="pro-head">
          <h3 style="margin: 0">人员详情 - {{ detail.nickname || "-" }}</h3>
          <button class="btn s xs" @click="$router.push('/personnel')" :disabled="loading">返回台账</button>
        </div>
        <div class="info">
          <div class="it"><b>昵称</b>{{ detail.nickname || "-" }}</div>
          <div class="it"><b>微信ID</b>{{ detail.wechat_id || "-" }}</div>
          <div class="it"><b>公司名称</b>{{ detail.company_name || "-" }}</div>
          <div class="it"><b>手机号</b>{{ detail.phone || "-" }}</div>
          <div class="it"><b>在线状态</b>{{ detail.online_status === "online" ? "在线" : "离线" }}</div>
          <div class="it"><b>设备类型</b>{{ detail.device_type || "-" }}</div>
          <div class="it"><b>设备ID</b>{{ detail.device_id || "-" }}</div>
          <div class="it"><b>登录时间</b>{{ detail.login_time || "-" }}</div>
          <div class="it"><b>TokenID</b>{{ detail.token_id || "-" }}</div>
        </div>
      </div>
    </div>

    <div class="pv-wrap">
      <section class="pv-panel">
        <div class="pv-head">
          <h3>系统提示词</h3>
          <div class="pv-actions">
            <small style="color: #64748b">版本 {{ promptVersion }}</small>
            <button class="btn s xs" @click="loadPromptTemplate" :disabled="loading || saveLoading">加载</button>
            <button class="btn p xs" @click="savePromptContent" :disabled="saveLoading">
              <span v-if="saveLoading">保存中...</span>
              <span v-else>保存</span>
            </button>
          </div>
        </div>
        <textarea v-model="prompt" class="prompt-editor" :disabled="loading || saveLoading"></textarea>
        <div class="rw">
          <span>{{ prompt.length }} 字</span>
          <span>预览：{{ promptPreview }}</span>
        </div>
      </section>

      <section class="pv-panel">
        <div class="pv-head">
          <h3>提示词验证对话</h3>
          <div class="pv-actions">
            <button class="btn s xs" @click="addMessage" :disabled="loading || testLoading">+ 新增消息</button>
            <button class="btn s xs" @click="exportContext" :disabled="loading || testLoading">导出上下文</button>
            <button class="btn p xs" @click="testPrompt" :disabled="testLoading">
              <span v-if="testLoading">测试中...</span>
              <span v-else>测试回复</span>
            </button>
          </div>
        </div>

        <div class="conv-list">
          <div v-if="!messages.length" class="conv-empty">暂无消息，点击“新增消息”开始验证对话</div>
          <div v-for="(m, i) in messages" :key="i" class="conv-row">
            <select v-model="m.role" class="role-select" :class="{ assistant: m.role === 'assistant' }" :disabled="loading || testLoading"></select>
            <textarea v-model="m.content" class="msg-input" :class="{ assistant: m.role === 'assistant' }" :disabled="loading || testLoading"></textarea>
            <button class="btn w xs" @click="removeMessage(i)" :disabled="loading || testLoading">删除</button>
          </div>
        </div>

        <div class="pv-bottom">
          <button class="btn w xs" @click="clearMessages" :disabled="loading || testLoading">清空</button>
          <span>{{ messages.length }} 条消息</span>
        </div>
        <textarea
          v-model="reply"
          class="reply-box"
          placeholder="测试回复结果将显示在这里"
          :disabled="loading || testLoading"
        ></textarea>
      </section>
    </div>
  </div>
</template>

<script>
import { personnelApi } from "../../api";

const DEFAULT_AVATAR =
  "data:image/svg+xml;charset=UTF-8," +
  encodeURIComponent(
    "<svg xmlns='http://www.w3.org/2000/svg' width='180' height='180' viewBox='0 0 180 180'><defs><linearGradient id='g' x1='0' y1='0' x2='1' y2='1'><stop offset='0' stop-color='#0f766e'/><stop offset='1' stop-color='#0ea5e9'/></linearGradient></defs><rect width='180' height='180' rx='24' fill='url(#g)'/><circle cx='90' cy='70' r='28' fill='rgba(255,255,255,.82)'/><rect x='42' y='106' width='96' height='44' rx='22' fill='rgba(255,255,255,.82)'/></svg>"
  );

function nextVersion(v) {
  const n = Number(String(v || "v1").replace(/[^\d]/g, "")) || 1;
  return `v${n + 1}`;
}

function localReply(prompt, messages) {
  const lastUser = [...messages].reverse().find((x) => x.role === "user");
  const q = (lastUser?.content || "").trim();
  if (!q) return "你好，请先输入一个用户问题，我会根据系统提示词生成一条测试回复。";
  const tone = prompt.includes("律师") ? "从法律咨询角度看，" : "";
  return `${tone}你提到“${q.slice(0, 80)}”，建议先确认关键信息（时间、证据、诉求），再按优先级逐步处理。`;
}

export default {
  data() {
    return {
      defaultAvatar: DEFAULT_AVATAR,
      detail: {},
      promptVersion: "v1",
      prompt: "你是一位专业的离婚律师，请根据客户描述给出专业、准确、可执行的建议。",
      messages: [
        { role: "assistant", content: "你好，是想咨询如何快速离婚吗？请回复“是”或“不是”请务必回复！！！" },
        { role: "user", content: "是" }
      ],
      reply: "",
      loading: false,
      saveLoading: false,
      testLoading: false
    };
  },
  computed: {
    promptPreview() {
      return this.prompt.length > 44 ? `${this.prompt.slice(0, 44)}...` : this.prompt;
    }
  },
  created() {
    this.loadDetail();
  },
  methods: {
    async loadDetail() {
      this.loading = true;
      try {
        const raw = await personnelApi.getPersonnelDetail(this.$route.params.id);
        this.detail = {
          id: raw.id,
          nickname: raw.nickname || "示例销售",
          wechat_id: raw.wechat_id || "wx_demo",
          company_name: raw.company_name || "勉之律师事务所",
          phone: raw.phone || "",
          online_status: raw.online_status || "online",
          device_type: raw.device_type || "PC",
          device_id: raw.device_id || "PC-DEMO-001",
          login_time: raw.login_time || "2026-02-22 10:20:30",
          token_id: raw.token_id || "TKN-9032-8891",
          avatar: raw.avatar || DEFAULT_AVATAR
        };
        if (raw.prompt) this.prompt = raw.prompt;
        if (Array.isArray(raw.messages)) this.messages = raw.messages;
        if (raw.prompt_version) this.promptVersion = raw.prompt_version;
      } catch (e) {
        this.detail = {
          id: Number(this.$route.params.id),
          nickname: "杜志豪",
          wechat_id: "wx_dzh_123456",
          company_name: "勉之律师事务所",
          phone: "",
          online_status: "online",
          device_type: "PC",
          device_id: "PC-DF3A-90S2",
          login_time: "2026-02-22 08:45:10",
          token_id: "TKN-9032-8891",
          avatar: DEFAULT_AVATAR
        };
      } finally {
        this.loading = false;
      }
    },
    loadPromptTemplate() {
      this.prompt =
        "你是一名专业婚姻法律咨询顾问，请以合规、克制、同理心的方式回复用户，避免夸大承诺。";
      this.$message.info("已加载模板提示词");
    },
    addMessage() {
      this.messages.push({ role: "user", content: "" });
    },
    removeMessage(index) {
      this.messages.splice(index, 1);
    },
    clearMessages() {
      if (!this.messages.length) return;
      this.$confirm("确认清空当前验证对话吗？", "提示", { type: "warning" }).then(() => {
        this.messages = [];
      });
    },
    async savePromptContent() {
      if (!this.prompt.trim()) {
        this.$message.error("提示词内容不能为空");
        return;
      }
      this.saveLoading = true;
      try {
        await personnelApi.savePrompt(this.$route.params.id, {
          prompt: this.prompt,
          messages: this.messages
        });
      } catch (e) {
        // dev mode without backend
      } finally {
        this.saveLoading = false;
        this.promptVersion = nextVersion(this.promptVersion);
        this.$message.success("提示词已保存");
      }
    },
    async testPrompt() {
      if (!this.prompt.trim()) {
        this.$message.error("请先填写系统提示词");
        return;
      }
      this.testLoading = true;
      try {
        const data = await personnelApi.verifyPrompt(this.$route.params.id, {
          prompt: this.prompt,
          messages: this.messages
        });
        this.reply = data.reply || localReply(this.prompt, this.messages);
      } catch (e) {
        this.reply = localReply(this.prompt, this.messages);
      } finally {
        this.testLoading = false;
        this.$message.success("已生成测试回复");
      }
    },
    exportContext() {
      try {
        const payload = {
          id: this.detail.id,
          nickname: this.detail.nickname,
          prompt: this.prompt,
          messages: this.messages,
          exportedAt: new Date().toISOString()
        };
        const blob = new Blob([JSON.stringify(payload, null, 2)], {
          type: "application/json;charset=utf-8"
        });
        const a = document.createElement("a");
        a.href = URL.createObjectURL(blob);
        a.download = `${this.detail.nickname || "人员"}_验证上下文_${Date.now()}.json`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(a.href);
        this.$message.success("上下文已导出");
      } catch (e) {
        this.$message.error("导出失败");
      }
    }
  }
};
</script>

<style scoped>
.d {
  display: grid;
  gap: 10px;
  min-width: 0;
}

.p {
  background: #fff;
  border: 1px solid #e8efec;
  border-radius: 13px;
  padding: 12px;
  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.06);
}

.pro {
  display: grid;
  grid-template-columns: 86px 1fr;
  gap: 10px;
  align-items: center;
}

.pro img {
  width: 82px;
  height: 82px;
  border-radius: 16px;
  border: 1px solid #dcece6;
  object-fit: cover;
  box-shadow: 0 10px 20px rgba(15, 23, 42, 0.12);
}

.pro-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 8px;
}

.info {
  display: grid;
  grid-template-columns: repeat(4, minmax(110px, 1fr));
  gap: 8px;
}

.it {
  background: #f8fcfa;
  border: 1px solid #eaf2ee;
  border-radius: 9px;
  padding: 8px;
}

.it b {
  display: block;
  color: #64748b;
  font-size: 12px;
  margin-bottom: 4px;
}

.pv-wrap {
  display: grid;
  grid-template-columns: 0.95fr 1.05fr;
  gap: 10px;
  align-items: start;
}

.pv-panel {
  background: #fff;
  border: 1px solid #e8efec;
  border-radius: 13px;
  padding: 12px;
  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.06);
  min-width: 0;
}

.pv-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 8px;
}

.pv-head h3 {
  margin: 0;
}

.pv-actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.prompt-editor {
  min-height: 320px;
  height: 360px;
  max-height: 52vh;
  width: 100%;
  border: 1px solid #dae7e2;
  border-radius: 11px;
  padding: 10px;
  font: inherit;
  line-height: 1.5;
  resize: none;
  overflow-y: auto;
  overflow-x: hidden;
  background: #fff;
}

.rw {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
  font-size: 12px;
  color: #64748b;
  margin-top: 8px;
}

.rw > span:nth-child(2) {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.conv-list {
  max-height: none;
  overflow: visible;
  padding-right: 4px;
  display: grid;
  gap: 8px;
}

.conv-empty {
  border: 1px dashed #cfe1da;
  border-radius: 10px;
  padding: 16px;
  color: #64748b;
  text-align: center;
  background: #f8fcfa;
}

.conv-row {
  display: grid;
  grid-template-columns: 92px minmax(0, 1fr) 56px;
  gap: 8px;
  align-items: start;
}

.role-select {
  width: 100%;
  height: 40px;
  border-radius: 8px;
  border: 2px solid #38bdf8;
  background: #eff6ff;
  color: #1e3a8a;
  font-weight: 700;
  padding: 0 8px;
  outline: none;
}

.role-select.assistant {
  border-color: #84cc16;
  background: #f0fdf4;
  color: #365314;
}

.msg-input {
  min-height: 84px;
  border-radius: 8px;
  border: 1px solid #dbe7e3;
  border-left: 6px solid #38bdf8;
  background: #fff;
  font: inherit;
  line-height: 1.5;
  padding: 8px;
  resize: vertical;
  overflow-y: auto;
  overflow-x: hidden;
}

.msg-input.assistant {
  border-left-color: #84cc16;
}

.pv-bottom {
  margin-top: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.reply-box {
  margin-top: 8px;
  width: 100%;
  min-height: 110px;
  max-height: 220px;
  border-radius: 11px;
  border: 1px solid #dbe7f9;
  background: #f8fbff;
  font: inherit;
  line-height: 1.5;
  padding: 10px;
  resize: vertical;
  overflow-y: auto;
  overflow-x: hidden;
}

.btn {
  border: 0;
  border-radius: 12px;
  padding: 9px 13px;
  cursor: pointer;
  font-family: inherit;
  font-weight: 600;
  transition: transform 0.16s ease, box-shadow 0.18s ease, filter 0.18s ease;
}

.btn:hover {
  transform: translateY(-1px);
}

.btn:active {
  transform: translateY(1px);
}

.btn.p {
  background: linear-gradient(130deg, #0f766e, #14b8a6);
  color: #fff;
  box-shadow: 0 10px 18px rgba(20, 184, 166, 0.34);
}

.btn.s {
  background: #fff;
  border: 1px solid #dae7e2;
  color: #334155;
}

.btn.w {
  background: #fff7ed;
  color: #b45309;
  border: 1px solid #fed7aa;
}

.btn.xs {
  padding: 6px 10px;
  font-size: 12px;
  border-radius: 10px;
}

@media (max-width: 1100px) {
  .info {
    grid-template-columns: repeat(2, minmax(110px, 1fr));
  }

  .pv-wrap {
    grid-template-columns: 1fr;
  }

  .prompt-editor {
    height: 280px;
    min-height: 280px;
    max-height: none;
  }
}

@media (max-width: 900px) {
  .info {
    grid-template-columns: 1fr;
  }

  .pro {
    grid-template-columns: 1fr;
  }
}

/* Loading styles */
.loading {
  position: relative;
}

.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  border-radius: inherit;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  backdrop-filter: blur(2px);
}

.loading-overlay::after {
  content: '';
  width: 32px;
  height: 32px;
  border: 3px solid rgba(15, 118, 110, 0.1);
  border-top-color: #0f766e;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* Ensure loading overlay works correctly */
.d {
  position: relative;
}

.p {
  position: relative;
}

.pv-panel {
  position: relative;
}
</style>
